import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Container, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import { createApplicationAction } from "../../../redux/actions/ApplicationAction";
import notify from "../../../Notifcation";
import { useNavigate } from "react-router-dom";

const Adss = () => {
  const [desc, setdesc] = useState("");
  const [Nationalid, setNationalid] = useState([]);
  const [Pssportss, setPssportss] = useState([]);
  const [NatOrPass, setNatOrPass] = useState("");

  const [segelcomm, setsegelcomm] = useState("");
  const [Certroom, setCertroom] = useState("");
  const [Taxcard, setTaxcard] = useState("");
  const [drawproduct, setdrawproduct] = useState([]);
  const [drawtarkep, setdrawtarkep] = useState([]);
  const [Adsloc, setAdsloc] = useState("");

  const [ChoseServ, setChoseServ] = useState("");

  const [Others, setOthers] = useState([]);
  const navegate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [isPress, setisPress] = useState(false);
  const handleFileChangeNational = (e) => {
    // Convert FileList to Array
    const files = Array.from(e.target.files);
    setNationalid(files);
  };
  const handleFileChangedrawproduct= (e) => {
    // Convert FileList to Array
    const files = Array.from(e.target.files);
    setdrawproduct(files);
  };
  const handleFileChangedrawtarkep= (e) => {
    // Convert FileList to Array
    const files = Array.from(e.target.files);
    setdrawtarkep(files);
  };
  const handleFileChangePass = (e) => {
    // Convert FileList to Array
    const files = Array.from(e.target.files);
    setPssportss(files);
  };
  // const handleFileChangeelevakd = (e) => {
  //   // Convert FileList to Array
  //   const files = Array.from(e.target.files);
  //   setelevakd(files);
  // };
  const handleFileChangeOther = (e) => {
    // Convert FileList to Array
    const files = Array.from(e.target.files);
    setOthers(files);
  };
  const handlesubmit = async (e) => {
    e.preventDefault();
    if (
      NatOrPass === "n"
        ? Nationalid === ""
        : NatOrPass === "p"
        ? Pssportss === ""
        : null
    ) {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setisPress(true);
    const formData = new FormData();
    formData.append("application_type", 7);
    formData.append("local_type", 4);
    formData.append("local_category", ChoseServ);
    formData.append("local_details", desc);
    formData.append("official_extract_commercial_register", segelcomm);
    formData.append("certificate_registration_relevant_chamber", Certroom);
    formData.append("tax_card", Taxcard);
    formData.append("document_exploitation_location_place", Adsloc);
    Nationalid.map((item) => {
      return formData.append("client_national_ids", item);
    });
    drawproduct.map((item) => {
      return formData.append("construction_drawings_advertising_stands", item);
    });
    drawtarkep.map((item) => {
      return formData.append("drawings_electrical_installations_connections", item);
    });
    Pssportss.map((item) => {
      return formData.append("passports", item);
    });
    // elevakd.map((item) => {
    //   return formData.append("engineering_drawings", item);
    // });
    Others.map((item) => {
      return formData.append("others", item);
    });
    await dispatch(createApplicationAction(formData));
    setLoading(false);
    setisPress(false);
    setdesc("");
    setNationalid("");
    setsegelcomm("");
    setCertroom("");
    setTaxcard("");
    setdrawproduct("");
    setdrawtarkep("");
    setAdsloc("");
    setChoseServ("");
    setOthers("");
  };
  const res = useSelector((state) => state.ApplicationReduser.createApp);

  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 1500);
      if (res) {
        if (res.status === 201 || res.status === 200) {
          if (res.data) {
            notify(res.data.message, "success");
            setTimeout(() => {
              navegate("/user/requestsuser");
            }, 3000);
          }
        } else if (res.status !== 201 || res.status !== 200) {
          if (res.data) {
            notify(res.data.message, "error");
          } else {
            notify("حدثة مشكلة حاول مرة اخرى", "error");
          }
        }
      }
    }
  }, [loading]);
  return (
    <Container>
      {" "}
      <h3 className="text-center mb-3 mt-3">خدمات الأعلانات </h3>
      <div className="inputs-container">
        <div className="inp-container">
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              {
                <Typography>
                  نوع الخدمة
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label={
                <Typography>
                  نوع الخدمة
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
              value={ChoseServ}
              onChange={(e) => setChoseServ(e.target.value)}
            >
              <MenuItem value={16}>
                طلب الحصول على ترخيص او تجديد بروز اعلان عربية
              </MenuItem>
            </Select>
          </FormControl>
        </div>
        <div className="inp-container">
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              {
                <Typography>
                  نوع مستند الشخصية
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label={
                <Typography>
                  نوع مستند الشخصية
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
              value={NatOrPass}
              onChange={(e) => setNatOrPass(e.target.value)}
            >
              <MenuItem value={"p"}>جواز سفر</MenuItem>
              <MenuItem value={"n"}>بطاقة شخصية</MenuItem>
            </Select>
          </FormControl>
        </div>
        {NatOrPass === "p" ? (
          <>
            <div className="inp-container ">
              <TextField
                label={
                  <Typography>
                    جواز السفر
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                focused
                inputProps={{
                  multiple: true,
                }}
                type="file"
                onChange={handleFileChangePass}
                variant="outlined"
              />
            </div>
          </>
        ) : NatOrPass === "n" ? (
          <>
            <div className="inp-container ">
              <TextField
                label={
                  <Typography>
                    البطاقة الشخصية
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                focused
                inputProps={{
                  multiple: true,
                }}
                type="file"
                onChange={handleFileChangeNational}
                variant="outlined"
              />
            </div>
          </>
        ) : null}
        {/* {ChoseServ===1?(
        <div className="inp-container">
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              {
                <Typography>
                  نوع الخدمة
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label={
                <Typography>
                  نوع الخدمة
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
              value={ChoseServSub}
              onChange={(e) => setChoseServSub(e.target.value)}
            >
              <MenuItem value={'construction'}>انشاء</MenuItem>
              <MenuItem value={'amendment'}>تعديل</MenuItem>
              <MenuItem value={'addition'}>اضافة</MenuItem>
              <MenuItem value={'external_finishes'}>تشطيبات خارجية</MenuItem>
              <MenuItem value={'complete'}>استكمال</MenuItem>
              <MenuItem value={'raising'}>تعلية</MenuItem>

            </Select>
          </FormControl>
        </div>
        ):(null)} */}

        <div className="inp-container ">
          <TextField
            label={"مستخرج رسمي من السجل التجاري"}
            focused
            // inputProps={{
            //   multiple: true,
            // }}
            type="file"
            onChange={(e) => setsegelcomm(e.target.files[0])}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={"صورة شهادة قيد بالغرفة المختصة"}
            focused
            // inputProps={{
            //   multiple: true,
            // }}
            type="file"
            onChange={(e) => setCertroom(e.target.files[0])}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={"صورة من البطاقة الضريبية"}
            focused
            // inputProps={{
            //   multiple: true,
            // }}
            type="file"
            onChange={(e) => setTaxcard(e.target.files[0])}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={"نسختان من الرسومات الأنشائية للحوامل بالأعلان"}
            focused
            inputProps={{
              multiple: true,
            }}
            type="file"
            onChange={handleFileChangedrawproduct}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={"نسختان من الرسومات للتركيبات و للتوصيلات الكهربائية "}
            focused
            inputProps={{
              multiple: true,
            }}
            type="file"
            onChange={handleFileChangedrawtarkep}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={"سند استغلال موقع الأعلان"}
            focused
            // inputProps={{
            //   multiple: true,
            // }}
            type="file"
            onChange={(e) => setAdsloc(e.target.files[0])}
            variant="outlined"
          />
        </div>
        {/* <div className="inp-container ">
          <TextField
            label={"الموافقات والمستندات والرسوم التي تحددها الجهة المختصة"}
            focused
            // inputProps={{
            //   multiple: true,
            // }}
            type="file"
            onChange={(e) => setAprovves(e.target.files[0])}
            variant="outlined"
          />
        </div> */}
        <div className="inp-container ">
          <TextField
            label={"تفاصيل"}
            multiline
            type="text"
            value={desc}
            onChange={(e) => {
              setdesc(e.target.value);
            }}
            variant="outlined"
          />
        </div>

        <div className="inp-container ">
          <TextField
            label={"اخرى"}
            focused
            inputProps={{
              multiple: true,
            }}
            type="file"
            onChange={handleFileChangeOther}
            variant="outlined"
          />
        </div>
        <div className="inp-container "></div>
        <div className="inp-container "></div>
      </div>
      {isPress && loading ? (
        <button className="buttonadd">
          <Spinner />
        </button>
      ) : (
        <button className="buttonadd" onClick={handlesubmit}>
          {" "}
          استكمال الطلب
        </button>
      )}
      <ToastContainer />
    </Container>
  );
};

export default Adss;
